import {
    MdVisibility,
    MdCheck,
    MdSnippetFolder,
    MdOutlineTextSnippet,
} from 'react-icons/md';
import { useSearchParams } from 'react-router-dom';
import { ReportingControllerBaseConfig } from '../../../../../base';
import { SnippetElementController } from './snippetElementInterface';
import { SnippetElementViewProps } from './snippetElementProps';
import { assert } from '@varos/util-typescript';

export function createSnippetElementController(
    config: ReportingControllerBaseConfig
): SnippetElementController {
    const { navigation } = config;

    return {
        useProps(item, props): SnippetElementViewProps {
            return {
                containerRef: props.containerRef,
                popover: {
                    isOpen: props.disclosure.popover.isOpen,
                    onClose: props.disclosure.popover.onClose,
                },
                property: {
                    label: item.property.display_name,
                    Icon: MdOutlineTextSnippet,
                },
                fullscreen: {
                    button: {
                        onClick(event) {
                            props.disclosure.fullscreen.onOpen();
                            event.preventDefault();
                            event.stopPropagation();
                        },
                        isDisabled: false,
                    },
                },
                field: {
                    isOpen: props.disclosure.popover.isOpen,
                    onOpen: props.disclosure.popover.onOpen,
                    onClose: props.disclosure.popover.onClose,
                    value: props.field.value,
                    onCreate(value) {
                        props.field.onChange(value ? { id: value.id } : null);
                    },
                    onUpdate(value) {
                        props.field.onChange(value ? { id: value.id } : null);
                    },
                    onClear() {
                        props.field.onChange(null);
                    },
                },
            };
        },
    };
}
